import { useQuery } from 'react-query';
import axios from 'axios';
import { ApiUser } from '../types';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

const getApiUsers = async (partnerId: number): Promise<ApiUser[]> => {
  const response = await axios.get(`/api/v4/partners/${partnerId}/api_users?include=oauth2-access-token`);
  return normalizeJSONAPIResponse(response.data);
};

export const useApiUsers = (partnerId?: number) => {
  return useQuery(['apiUsers', partnerId], () => getApiUsers(partnerId!), {
    enabled: !!partnerId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
